import { atom, useAtom } from "jotai";

import { defaultPositions } from "#/config/accounts";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { type PositionsByPairs } from "#/types/accounts";
import { type Market } from "#/types/markets";

import { useAccount } from "./account";

export const positionsAtom = atom<PositionsByPairs>(defaultPositions);

export const usePositions = (market?: Market) => {
  const [positions, setPositions] = useAtom(positionsAtom);

  const { account } = useAccount();
  const { market: positionDrawerMarket } = usePositionsDrawerMarket();

  return {
    positions: account
      ? positions[market?.pair ?? positionDrawerMarket.pair]
      : [],
    setPositions,
  };
};
